import React, { ReactNode, useEffect } from 'react';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { initPostHog, stopPostHog } from 'scalarAnalytics/postHog';

interface AnalyticsProviderProps {
  children: ReactNode;
}

const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
  const [{ user }] = useStore() as unknown as UseStoreValues;

  // Keep PostHog identity tied to the authenticated store user; logout/no-user resets it.
  useEffect(() => {
    if (user) {
      initPostHog(user);
    } else {
      stopPostHog();
    }
  }, [user]);

  return <span>{children}</span>;
};

export default AnalyticsProvider;
